export var FeeActionType;
(function (FeeActionType) {
    FeeActionType["FeesApprovedInsideCommitment"] = "FeesApprovedInsideCommitment";
    FeeActionType["FeesApprovedOutsideCommitment"] = "FeesApprovedOutsideCommitment";
})(FeeActionType || (FeeActionType = {}));
export const FeeActionTypeLabels = {
    [FeeActionType.FeesApprovedInsideCommitment]: 'Inside Commitment',
    [FeeActionType.FeesApprovedOutsideCommitment]: 'Outside Commitment',
};
//# sourceMappingURL=index.js.map